<template>
	<div>
		<section class="about-area" id="about">
			<div class="container">
				<div class="row">
					<div class="col-12 about-content-header my-3">
						<span class="water-text">About Me</span>
						<h2 class="page-section-heading text-center mb-0">About Me</h2>
						<div class="divider-custom">
							<div class="divider-custom-line" />
							<div class="divider-custom-icon">
								<i class="fas fa-star" />
							</div>
							<div class="divider-custom-line" />
						</div>
					</div>
					<div v-view="inAbout" class="col-md-6 about-content-left">
						<div class="d-flex justify-content-center">
							<a class="img-link" href="">
								<img
									class="portrait"
									src="images/portrait_img/shams.jpg"
									alt=""
								/>
								<div class="portrait_frame" />
							</a>
						</div>
					</div>
					<div class="col-md-6 text-justify my-5 about-desc">
						Hello! I'm <span>Shamsiar Hamid</span>, a
						<span>Full-stack Web Developer</span> specialized in building and
						designing exceptional, high-quality responsive web application for
						<span>4+ years</span>. Currently working at <span>79mplus</span> as
						a <span>Software Engineer</span>. I enjoy figuring out how things
						work and making thoughtful, engaging and functional web applications
						that have a clean and simple design. I’ve built web applications
						using <span class="green">HTML5</span>,
						<span class="green">CSS3</span>, <span class="green">SCSS</span>,
						<span class="green">Bootstrap</span>,
						<span class="green">Javascript</span>,
						<span class="green">JQuery</span>, <span class="green">PHP</span>,
						<span class="green">MySQL</span>, <span class="green">Vue.js</span>,
						<span class="green">Laravel</span>,
						<span class="green">CakePhp</span>,
						<span class="green">CodeIgniter</span>,
						<span class="green">Wordpress</span> and have a foundation in
						software <span>Architect</span>, <span>Design</span> and
						<span>Development</span>. <br />
						<button class="btn down_cv btn-lg mt-5 mt-md-4">
							<i class="fas fa-download mr-2" /><a
								href="https://www.dropbox.com/scl/fi/dn54iuer0r1orm8fw2665/Shamsiar-Hamid_CV_2022.docx?dl=0&rlkey=bl4v4warw1ehbryni48emk74a"
								target="_blank"
								>Resume</a
							>
						</button>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	methods: {
		inAbout() {
			this.$emit("inAbout");
		},
	},
};
</script>

<style lang="scss" scoped></style>
